import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Color, AnchorBase } from '@figure/frontlib-gui';

const Container = styled.div`
  padding: 2rem;
  border: 1px solid ${Color.GREY_3};
  text-align: center;
`;

const Anchor = styled(AnchorBase)`
  font-size: 1.3em;
  font-weight: 500;
  color: ${Color.PURPLE_RAIN};
`;

const IncomePartiallyVerified = ({ uuid }) => (
  <Container>
    <Anchor to={`/applications/${uuid}/income/upload/paystub`} semanticElement={Link}>
      I would like to manually upload my most recent paystub
    </Anchor>
  </Container>
);

IncomePartiallyVerified.propTypes = {
  uuid: PropTypes.string.isRequired,
};

export default IncomePartiallyVerified;
